import { styled } from '@fluentui/react';
import { connect } from 'react-redux';
import { SourceApps } from '../../../models/constants/constants';
import { IAppState } from '../../../models/reduxState';
import { getUpsellMetaDataKey } from '../../../utilities';
import { eduProductIdSelector, isAmcSelector, isBATenantSelector, isBusinessAssistUXEnabledSelector, isCMCRequestCreationDeeplinkSelector, isNonAgaveSelector, sourceAppSelector } from '../../app/selectors/contactUsSelector';
import { RequestCreation } from '../presentationalComponents/RequestCreation';
import { updateDraftRequestWorkSpaceId } from '../reduxUpdater/actions/attachmentsActions';
import { updateIsPhoneNumberValid, updateIsEmailValid, updateDraftRequest, navigateToPage, navigateBack, updateSelectedEduProduct } from '../reduxUpdater/actions/modalitySectionActions';
import { setContactSearchedQueryText } from '../reduxUpdater/actions/sharedStateActions';
import { dispatchCreateRequest } from '../reduxUpdater/dispatchers/contactUsDispatchers';
import { customerAvailabilityConfirmedSelector, businessImpactConfirmedSelector, additionalRequestCreationFieldsSelector, showUserImpactAndRoleDropdownSelector } from '../reduxUpdater/selectors/commonSelectors';
import { isUnifiedPremierSelector, isUnifiedEnterprisePremierSelector, isNonUnifiedPremierSelector, isPremierTenantEnabledSelector, premierEntitlementIdSelector } from '../reduxUpdater/selectors/globalStateSelectors';
import { isAttachmentsEnabledSelector, severitySelector } from '../reduxUpdater/selectors/requestSelector';
import { regionInfoSelector } from '../reduxUpdater/selectors/sharedStateSelectors';
import { getContactUsStyles } from '../styles/contactUsStyles';

const mapStateToProps = (state: IAppState, _ownProps: any) => {
  return {
    draftRequest: state.ContactState.ModalitySectionState.draftRequest,
    modalityResponse: state.ContactState.ModalitySectionState.modalityResponse,
    regionInfo: regionInfoSelector(state),
    alchemyThemeRoutingShowWaitTime: state.ContactState.ModalitySectionState.alchemyThemeRoutingShowWaitTime,
    isPhoneNumberValid: state.ContactState.ModalitySectionState.isPhoneNumberValid,
    isEmailValid: state.ContactState.ModalitySectionState.isEmailValid,
    isTitleValid: state.ContactState.ModalitySectionState.isTitleValid,
    showModalitiesStickyFooter: state.ContactState.SelfHelpAlchemyState.showModalitiesStickyFooter,
    isUserImpactAndRoleDropdownEnabled: showUserImpactAndRoleDropdownSelector(state),
    isC2CCountryCodeEnabled: state.ContactState.ModalitySectionState.isC2CCountryCodeEnabled,
    userImpactOptions: state.ContactState.ModalitySectionState.userImpactOptions,
    userRoleOptions: state.ContactState.ModalitySectionState.userRoleOptions,
    isOutlookDotCom: state.ContactState.SharedState.isOutlookDotCom,
    contactSearchedQuery: state.ContactState.SharedState.contactSearchedQuery,
    isAttachmentsEnabled: isAttachmentsEnabledSelector(state),
    isUploadAttachmentInProgress: state.ContactState.AttachmentsState.isUploadAttachmentInProgress,
    upsellMetaDataKey: getUpsellMetaDataKey(state.ContactState.ModalitySectionState.draftRequest),
    isSignUp: state.GlobalState.sourceApp === SourceApps.SignUp,
    isUnifiedPremier: isUnifiedPremierSelector(state),
    isUnifiedEnterprisePremier: isUnifiedEnterprisePremierSelector(state),
    isNonUnifiedPremier: isNonUnifiedPremierSelector(state),
    premierEntitlementId: premierEntitlementIdSelector(state),
    businessImpactConfirmed: businessImpactConfirmedSelector(state),
    customerAvailabilityConfirmed: customerAvailabilityConfirmedSelector(state),
    severity: severitySelector(state),
    isPremierTenantEnabled: isPremierTenantEnabledSelector(state),
    sourceApp: sourceAppSelector(state),
    isAmc: isAmcSelector(state),
    isNonAgave: isNonAgaveSelector(state),
    isBATenant: isBATenantSelector(state),
    isBusinessAssistUXEnabled: isBusinessAssistUXEnabledSelector(state),
    eduProductId: eduProductIdSelector(state),
    additionalFields: additionalRequestCreationFieldsSelector(state),
    isWindowsCopilotRequestCreationDeeplink: state.ContactState.SharedState.isWindowsCopilotRequestCreationDeeplink,
    isCMCRequestCreationDeeplink: isCMCRequestCreationDeeplinkSelector(state),
  };
};

const mapDispatchToProps = {
  updateIsPhoneNumberValid,
  updateIsEmailValid,
  updateDraftRequest,
  navigateToPage,
  navigateBack,
  dispatchCreateRequest,
  setContactSearchedQueryText,
  updateDraftRequestWorkSpaceId,
  updateSelectedEduProduct
};

export const RequestCreationContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(RequestCreation, getContactUsStyles));
